import i18n from 'i18next';
import { setDefaultOptions } from 'date-fns';
import sprintf from 'i18next-sprintf-postprocessor';
import languageDetector from 'i18next-browser-languagedetector';
import dateLocales from '../constants/dateLocales.js'; // @ts-nocheck

/*
 * i18n Initialization singleton
 *
 * @param resources object
 *
 * A static Object passed per-application that encompasses language, namespace, and translations.
 * Example:
 * {
 *  en: {
 *  exampleNamesapce: require('locales/en/translations.json')
 *  },
 *  ...
 * }
 */

var i18nInstance = function i18nInstance(resources) {
  var namespace = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'defaultNamespace';
  return function (resources, namespace) {
    var instance = null;

    function createInstance(resources, namespace) {
      return typeof window !== 'undefined' && window.i18nDashiFi || setup_i18n(resources, namespace);
    }

    return {
      getInstance: function getInstance() {
        if (!instance) instance = createInstance(resources, namespace);
        return instance;
      }
    };

    function setup_i18n(resources, namespace) {
      var newInstance = i18n.createInstance();
      newInstance.use(sprintf).use(languageDetector).init({
        resources: {},
        partialBundledLanguages: true,
        fallbackLng: ['en'],
        fallbackNS: ['defaultNamespace'],
        ns: [namespace],
        defaultNS: namespace,
        debug: false,
        keySeparator: '>',
        nsSeparator: '|',
        returnObjects: true,
        returnEmptyString: false,
        interpolation: {
          escapeValue: false,
          formatSeparator: ',',
          format: function format(value, _format) {
            if (_format === 'uppercase') return value.toUpperCase();
            return value;
          }
        },
        detection: {
          order: ['querystring', 'htmlTag', 'cookie', 'navigator'],
          // order and from where user language should be detected
          lookupQuerystring: 'locale',
          // keys or params to lookup language from
          lookupCookie: 'locale'
        }
      });
      setDefaultOptions({
        locale: dateLocales[i18n.language] || dateLocales.en
      });
      return newInstance;
    }
  }(resources, namespace);
};

export { i18nInstance };